<script setup lang="ts">
import { onBeforeUnmount, ref, watch } from 'vue'

defineProps<{
  name: string
  link?: string | null
}>()

const textRef = ref<HTMLElement | null>(null)
const isTruncated = ref(false)

const updateTruncated = () => {
  const el = textRef.value
  isTruncated.value = el ? el.scrollWidth > el.clientWidth : false
}

// 表示幅やフォント読み込みで幅が変わっても省略判定を追従させる。
// link の有無で監視対象の要素が入れ替わるため textRef の変化にも追随する。
const resizeObserver = new ResizeObserver(updateTruncated)
watch(
  textRef,
  (el, prev) => {
    if (prev) resizeObserver.unobserve(prev)
    if (el) resizeObserver.observe(el)
  },
  { immediate: true, flush: 'post' }
)

onBeforeUnmount(() => resizeObserver.disconnect())
</script>

<template>
  <el-tooltip :content="name" placement="bottom" :disabled="!isTruncated">
    <router-link v-if="link" :to="{ path: link }" class="breadcrumb-link">
      <span ref="textRef" class="breadcrumb-name">{{ name }}</span>
    </router-link>
    <span v-else ref="textRef" class="breadcrumb-name">{{ name }}</span>
  </el-tooltip>
</template>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.breadcrumb-name {
  display: inline-block;
  max-width: $spacing-unit * 40;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: bottom;
  white-space: nowrap;
}

.breadcrumb-link {
  color: $text-color-white;
  text-decoration: none;

  &:hover {
    opacity: 0.8;
  }
}
</style>
